import * as VueRouter from 'vue-router'
import { alternativeLanguage } from '@/utils'

import Home from '@/views/Home.vue'
import Default from '@/views/Default.vue'
import Error from '@/views/Error.vue'

const multilanguageRoutes = [
  { path: '/', redirect: () => document.documentElement.lang || 'fi' },
  {
    name: 'Language',
    path: '/:language',
    children: [
      { name: 'Home',    path: '',                            component: Home },
      { name: 'Error',   path: 'error',                       component: Default },
      { name: 'Default', path: ':primi',                      component: Default },
      { name: 'Subpage', path: ':primi/:secondi',             component: Default },
      { name: 'Detail',  path: ':primi/:secondi/:dessert',    component: Default },
    ]
  }
]

const singleLanguageRoutes = [
  { path: '/home', redirect: '/' },
  { name: 'Home',    path: '/',                          component: Home },
  { name: 'Error',   path: '/error',                     component: Default },
  { name: 'Default', path: '/:primi',                    component: Default },
  { name: 'Subpage', path: '/:primi/:secondi',           component: Default },
  { name: 'Detail',  path: '/:primi/:secondi/:dessert',  component: Default },
]

const routes = alternativeLanguage() ? multilanguageRoutes : singleLanguageRoutes

export const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    setTimeout(() => window.scrollTo(0, 0), 100)
  }
})
